import { Component, OnInit } from '@angular/core';
import { AnnouncementModel, AnnouncementQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';

@Component({
  selector: 'fgbcl-announcements',
  templateUrl: 'announcements.component.html',
  styleUrls: ['./announcements.component.scss'],
})
export class AnnouncementsComponent implements OnInit {
  announcements$: Observable<AnnouncementModel[]>;
  customOptions: OwlOptions = {
    items: 1,
    autoHeight: false,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    navSpeed: 700,
    dots: true,
    responsive: {
      900: { autoWidth: false, autoHeight: false },
    },
  };

  constructor(private announcementQuery: AnnouncementQuery) {}

  ngOnInit() {
    this.announcements$ = this.announcementQuery.announcements();
  }
}
